'use client';

import AppLayout from '@/components/AppLayout';
import FlyerBuilderContent from './components/FlyerBuilderContent';

export default function FlyerBuilderPage() {
  return (
    <AppLayout>
      <FlyerBuilderContent />
    </AppLayout>
  );
}
